<template>
    <div class="site-width uk-animation-fade single">
        <Seo
            :canonical="'/' + $t('berlinale2026').toLowerCase()"
            :title="$t('berlinale2026')" />

        <div class="menu-headline-distance" />

        <div class="uk-text-center">
            <img
                id="reg-success"
                :src="
                    require('../../assets/' +
                        getMode +
                        '/images/berlinale2025.png')
                "
                class="logo-img"
                uk-img />
        </div>
        <div class="uk-margin-large-top" />

        <div v-if="loading" class="uk-text-center">
            <div uk-spinner />
        </div>
        <div v-else-if="error" class="uk-text-center">
            <div
                class="uk-card uk-card-alternative uk-padding site-width single">
                <SiteHeadline
                    switch-headline
                    is-main
                    headline="Bitte verwende den Link aus der Einladung. Falls das Problem besteht, kontaktiere uns."
                    message="Ungültiger Link"
                    has-button>
                </SiteHeadline>
            </div>
        </div>
        <div v-else-if="invite.reply && invite.reply === 'denied'">
            <div
                class="uk-card uk-card-alternative uk-padding site-width single">
                <SiteHeadline
                    switch-headline
                    is-main
                    headline="Schade, dass du diesmal nicht dabei bist, hoffentlich klappt es nächstes mal!"
                    message="Danke für deine Rückmeldung."
                    has-button>
                </SiteHeadline>
            </div>
        </div>
        <div
            class="uk-animation-fade"
            v-else-if="
                success || (invite.reply && invite.reply === 'accepted')
            ">
            <div
                class="uk-card uk-card-alternative uk-padding site-width single">
                <SiteHeadline
                    switch-headline
                    is-main
                    :headline="
                        $t('invite.berlinale.26', {forename: invite.forename})
                    "
                    message="Danke für Deine Anmeldung zum Berlinale Empfang 2026"
                    has-button>
                </SiteHeadline>
            </div>
            <div class="headline-message-distance" />

            <div class="data-struct site-width single uk-text-center">
                <div class="text-bold">
                    Füge den Termin bequem zu deinem Kalender hinzu.
                </div>
                <div class="uk-margin-small-top" />

                <div><span class="text-bold">Wann:</span> 15.02.2026</div>
                <div>
                    <span class="text-bold">Uhrzeit:</span> 14:00 Uhr bis 19:00
                    Uhr
                </div>
                <div>
                    <span class="text-bold">Wo:</span> Fabrik 23, Gerichtstraße
                    23, 13347 Berlin
                </div>
            </div>

            <div v-if="false" class="uk-margin-medium-top uk-text-center">
                <Button has-action :action="addCal" is-large mode="success">
                    Zum Kalender hinzufügen
                </Button>
            </div>
        </div>
        <div v-else>
            <SiteHeadline
                switch-headline
                is-main
                headline="Die Anmeldung für die Gästeliste erfolgt über das unten stehende Anmeldeformular.<br/>Bitte beachte, dass ohne Anmeldung keine Teilnahme am Event möglich ist."
                message="Herzliche Einladung zum Berlinale Empfang 2026"
                has-button>
            </SiteHeadline>
            <div class="headline-message-distance" />

            <div class="data-struct site-width single uk-text-center">
                <div v-if="false" class="text-bold uk-margin-small-bottom">
                    Infos zum Event
                </div>

                <div><span class="text-bold">Wann:</span> 15.02.2026</div>
                <div>
                    <span class="text-bold">Uhrzeit:</span> 14:00 Uhr bis 19:00
                    Uhr
                </div>
                <div>
                    <span class="text-bold">Wo:</span> Fabrik 23, Gerichtstraße
                    23, 13347 Berlin
                </div>
            </div>

            <div
                class="data-struct site-width single uk-text-center uk-margin-medium-top">
                <div class="text-bold uk-margin-small-bottom">
                    Infos zu den Spenden
                </div>

                <div>
                    In diesem Jahr unterstützt Cancel Cancer krebskranke Kinder
                    mit gezielter Ernährungs- und Bewegungstherapie. Mit Deiner
                    Spende hilfst Du neue Kraft und Lebensfreude zu schenken.
                </div>

                <div
                    class="uk-grid uk-child-width-auto uk-margin-medium-top uk-flex-center"
                    uk-grid>
                    <div>
                        <a
                            href="https://www.paypal.com/donate/?hosted_button_id=SZZVSE8W73FQG"
                            target="_blank">
                            <img
                                class="paypal-logo"
                                :src="
                                    require('../../assets/' +
                                        getMode +
                                        '/images/paypal.svg')
                                " />

                            <div class="uk-margin-small-top" />

                            <Button mode="primary" is-large
                                >PayPal Spende
                            </Button>
                        </a>
                    </div>
                </div>
            </div>

            <div class="uk-margin-large-top" />
            <SiteHeadline headline="Anmeldung für die Gästeliste" />
            <div
                class="uk-text-center uk-margin-small-top"
                v-if="invite.slots !== undefined">
                <span class="uk-badge">
                    {{ invite.slots }}
                    {{ invite.slots === 1 ? 'Platz' : 'Plätze' }} übrig
                </span>
            </div>
            <div class="headline-item-distance" />
            <div
                class="uk-card uk-card-alternative uk-dark-card-hovered uk-padding site-width single">
                <div
                    class="uk-text-large uk-text-center"
                    v-if="invite.slots !== undefined && invite.slots === 0">
                    Für diesen Link wurden alle Plätze bereits genutzt.
                </div>
                <EventForm
                    v-else
                    :invite="invite"
                    @forename="setForename"
                    @success="setSuccess()"
                    @denied="setDenied()" />
            </div>
        </div>

        <div
            v-if="!(success || (invite.reply && invite.reply === 'accepted'))"
            class="uk-margin-large-top" />
        <div
            v-if="!(success || (invite.reply && invite.reply === 'accepted'))"
            class="bottom-text uk-text-center">
            <div>
                Falls Du Fragen oder Anregungen hast, melde Dich jederzeit gerne
                bei uns:
            </div>

            <div class="text-bold">event@cancelcancer.de</div>
            <div class="text-bold">Dein Cancel Cancer Team</div>
        </div>

        <div class="uk-margin-medium-top" />
        <div class="uk-text-center">
            <span class="text-bold">Cancel Cancer e.V.</span><br />
            Entenmoorweg 45<br />
            27578 Bremerhaven<br />
            info@cancelcancer.de<br />
            www.cancelcancer.de<br />
        </div>

        <div class="last-button-distance" />
    </div>
</template>

<script>
import Seo from '../../components/Seo.vue';
import SiteHeadline from '@/components/SiteHeadline.vue';
import EventForm from './EventForm.vue';
import Button from '../../components/Button.vue';
import UIkit from 'uikit';
import axios from 'axios';

export default {
    name: 'Berlinale2025',
    components: {
        Button,
        EventForm,
        SiteHeadline,
        Seo,
    },
    data() {
        return {
            success: false,
            invite: {
                reply: undefined,
                slots: undefined,

                email: '',
                forename: '',
                surname: '',
                salutation: '',
            },
            loading: true,
            error: null,
        };
    },
    created() {
        if (this.getMode !== 'cancelcancer') {
            this.routeTo('');
        }

        this.getValidate();
    },
    methods: {
        getValidate() {
            let http = axios.create();

            this.loading = true;
            http.get(this.getBaseUrl + '/api/invites/validate', {
                headers: {
                    token: this.$route.query.token,
                },
            })
                .then((response) => {
                    this.invite = response.data;
                    this.loading = false;
                })
                .catch((e) => {
                    this.error = e;
                    this.loading = false;
                });
        },
        setDenied() {
            this.getValidate();
        },
        setForename(forename) {
            console.log(forename);
            if (!forename) {
                return;
            }

            this.invite.forename = forename;
        },
        setSuccess() {
            this.success = true;

            UIkit.scroll('#reg-success').scrollTo('#reg-success');
        },
        addCal() {
            const event = {
                uid: 'event@cancelcancer.de',
                dtstamp:
                    new Date()
                        .toISOString()
                        .replace(/[-:]/g, '')
                        .split('.')[0] + 'Z', // Current timestamp in UTC
                dtstart: '20260225T170000',
                dtend: '20260225T220000',
                summary: 'Cancel Cancer & Friends Berlinale 2026',
                location: 'Fabrik 23, Gerichtstraße 23, 13347 Berlin',
                description: '',
            };

            const timezone = `
BEGIN:VTIMEZONE
TZID:Europe/Berlin
X-LIC-LOCATION:Europe/Berlin
BEGIN:STANDARD
TZOFFSETFROM:+0200
TZOFFSETTO:+0100
TZNAME:CET
DTSTART:19701025T030000
RRULE:FREQ=YEARLY;BYDAY=-1SU;BYMONTH=10
END:STANDARD
BEGIN:DAYLIGHT
TZOFFSETFROM:+0100
TZOFFSETTO:+0200
TZNAME:CEST
DTSTART:19700329T020000
RRULE:FREQ=YEARLY;BYDAY=-1SU;BYMONTH=3
END:DAYLIGHT
END:VTIMEZONE
    `.trim();

            const icsContent = `
BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//CancelCancer//NONSGML Berlinale 2026//DE
CALSCALE:GREGORIAN
${timezone}
BEGIN:VEVENT
UID:${event.uid}
DTSTAMP:${event.dtstamp}
DTSTART;TZID=Europe/Berlin:${event.dtstart}
DTEND;TZID=Europe/Berlin:${event.dtend}
SUMMARY:${event.summary}
LOCATION:${event.location}
DESCRIPTION:${event.description}
END:VEVENT
END:VCALENDAR
    `.trim();

            const blob = new Blob([icsContent], {
                type: 'text/calendar;charset=utf-8',
            });

            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'event.ics';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
        },
    },
};
</script>

<style lang="scss" scoped>
.logo-img {
    max-height: 150px;
}

.text-bold {
    font-weight: 500;
}

.data-struct {
    font-size: 20px;
}

.bottom-text {
    font-size: 18px;
}

.paypal-logo {
    max-width: 120px;
    margin-bottom: 10px;
}

.uk-badge {
    border: 1px solid #eee !important;
    color: #fff !important;
    background: transparent !important;

    min-width: 22px;
    height: 22px;
    padding: 15px 20px;
    font-size: 16px;
}
</style>
